import { BrainfishColors } from '@brainfish-ai/components';

// Extract hex fallback from CSS variable string: "var(--name, #hex)" -> "#hex"
const extractHex = (cssVar: string) => cssVar.match(/#[0-9A-Fa-f]{6}/)?.[0] ?? cssVar;

// Light 200 shades for #262626 text contrast (extract hex to bypass dark mode swapping)
export const ACCESSIBLE_COLORS = [
  BrainfishColors.blue[200],
  BrainfishColors.green[200],
  BrainfishColors.purple[200],
  BrainfishColors.orange[200],
  BrainfishColors.pink[200],
  BrainfishColors.teal[200],
  BrainfishColors.magenta[200],
  BrainfishColors.red[200],
  BrainfishColors.yellow[200],
  BrainfishColors.lime[200],
].map(extractHex);

export const getAccessibleColor = () => ACCESSIBLE_COLORS[Math.floor(Math.random() * ACCESSIBLE_COLORS.length)];

/** Milkdown throws this family of errors when ctx slots are read after editor teardown. */
export function isMilkdownContextNotFoundError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);

  return message.includes('Context "') && message.includes('not found');
}

/** After `connected`, treat remote as ready if `synced` never fires (mount + onSynced). */
export const REMOTE_SYNC_FALLBACK_MS = 1000;

/** Timeout for clearing IndexedDB cache before connecting to Hocuspocus. */
export const CLEAR_TIMEOUT_MS = 3000;

/** Skip y-indexeddb when less than this many bytes remain in the origin quota. */
export const MIN_INDEXEDDB_FREE_BYTES = 10 * 1024 * 1024; // 10MB

/** Skip y-indexeddb when origin storage usage exceeds this fraction of quota. */
export const MAX_INDEXEDDB_USAGE_RATIO = 0.95; // 95%
